import { render, staticRenderFns } from "./StripeSetupForm.vue?vue&type=template&id=48d9e031"
import script from "./StripeSetupForm.vue?vue&type=script&lang=js"
export * from "./StripeSetupForm.vue?vue&type=script&lang=js"
import style0 from "./StripeSetupForm.vue?vue&type=style&index=0&id=48d9e031&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports